import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const GET_FORM_PDF_REQUEST = 'GET_FORM_PDF_REQUEST';
export const GET_FORM_PDF_SUCCESS = 'GET_FORM_PDF_SUCCESS';
export const GET_FORM_PDF_FAILURE = 'GET_FORM_PDF_FAILURE';
export const GET_FORM_PDF_RESET = 'GET_FORM_PDF_RESET';

function requestGetFormPdf() {
  return {
    type: GET_FORM_PDF_REQUEST,
    isFetchingPdfForm: true
  };
}

function receiveGetFormPdf(pdfFile) {
  return {
    type: GET_FORM_PDF_SUCCESS,
    isFetchingPdfForm: false,
    pdfFile,
    getFormPdfError: null
  };
}

function rejectGetFormPdf(getFormPdfError) {
  return {
    type: GET_FORM_PDF_FAILURE,
    isFetchingPdfForm: false,
    getFormPdfError
  };
}

function resetPdfDownloadState() {
  return {
    type: GET_FORM_PDF_RESET,
  };
}

export function getFormPdf(file) {
  return (dispatch) => {
    dispatch(requestGetFormPdf());

    const promise = () => ApiService
      .getFormPdf(file, { responseType: 'arraybuffer' })
      .then((response) => {
        file.blob = response.data;
        dispatch(receiveGetFormPdf(file));
      }).catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response) {
          const status = error.response && error.response.status;
          if (status !== 401) {
            if (status === 404) {
              error.response.data = { code: status, message: 'Form PDF not found or exceeds maximum file download size' };
            }
            dispatch(
              handleException(error, rejectGetFormPdf, !status || (status !== 401))
            );
          }
        } else if (error.retries && error.retries > 1) {
          dispatch(
            handleException(error, rejectGetFormPdf, false)
          );
        }
      });
    return promise();
  };
}

export function switchFormPdf(file) {
  return (dispatch) => {
    dispatch(requestGetFormPdf());
    dispatch(receiveGetFormPdf(file));
  };
}

export function resetPdfDownloads() {
  return dispatch => dispatch(resetPdfDownloadState());
}
